import { httpRequest } from "../../utils/HttpRequest";
import {
    IBillCancel,
    IBillCashDetail,
    IBillCashFields,
    IBillCashSearch,
    IBillDetail,
    IBIllFields,
    IBillLogDetail,
    IBillLogSearch,
    IBillSearch,
    IBillSummary,
    IBillWriteoffDetail,
    IBillWriteoffFields,
    IBillWriteoffSearch

} from "./BillTypes";
import { IPage, IRet } from "../../types/FmsTypes";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";
import { appHttpRequest } from "@/utils/AppHttpRequest";

class BillService {
    //新增账单
    insert(param: IBIllFields) {
        const apiUrl = "/bill/insert";
        return httpRequest
            .post<IBillDetail>(apiUrl, param);
    }
    insertTemp(param: IBIllFields) {
        const apiUrl = "/bill/insertTemp";
        return httpRequest
            .post<IBillDetail>(apiUrl, param);
    }

    //账单审核
    approval(param: IBillDetail) {
        const apiUrl = "/bill/approval";
        return httpRequest
            .post<boolean>(apiUrl, param);
    }

    //取消账单
    cancel(param: IBillCancel) {
        const apiUrl = "/bill/cancel";
        return httpRequest
            .post<boolean>(apiUrl, param);
    }

    //取消账单审核
    cancelApproval(param: IBillCancel) {
        const apiUrl = "/bill/cancel/approval";
        return httpRequest
            .post<boolean>(apiUrl, param);
    }

    //账单查询(分页)
    page(param: IBillSearch) {
        const apiUrl = "/bill/page";
        return httpRequest
            .post<IPage<IBillDetail>>(apiUrl, param, { timeout: 300000 });
    }

    //账单查询(单条)
    one(code: string) {
        const apiUrl = "/bill/one/" + code;
        return httpRequest
            .post<IBIllFields>(apiUrl);
    }

    //账单核销
    writeoff(param: IBillWriteoffFields) {
        const apiUrl = "/bill/writeoff";
        return httpRequest
            .post<IBillWriteoffDetail>(apiUrl, param);
    }

    //账单统计
    async billSummary(param: IBillSearch) {
        const apiUrl = "/bill/billSummary";
        return await httpRequest
            .post<IBillSummary>(apiUrl, param);
    }

    //账单核销记录查询(分页)
    writeoffPage(param: IBillWriteoffSearch) {
        const apiUrl = "/bill/writeoff/page";
        return httpRequest
            .post<IPage<IBillWriteoffDetail>>(apiUrl, param);
    }

    //账单现金收款
    cash(param: IBillCashFields) {
        const apiUrl = "/bill/cash";
        return httpRequest
            .post<boolean>(apiUrl, param);
    }

    //新增账单现金收款明细
    cashInsert(param: IBillCashFields) {
        const apiUrl = "/bill/cash/insert";
        return httpRequest
            .post<IBillCashDetail>(apiUrl, param);
    }

    //确认账单现金收款明细
    cashConfirm(code: string) {
        const apiUrl = "/bill/cash/confirm/" + code;
        return httpRequest
            .post<boolean>(apiUrl);
    }

    //修改账单现金收款
    cashUpdate(param: IBillCashFields) {
        const apiUrl = "/bill/cash/update";
        return httpRequest
            .post<boolean>(apiUrl, param);
    }

    //删除账单现金收款
    cashDelete(code: string) {
        const apiUrl = "/bill/cash/delete/" + code;
        return httpRequest
            .post<boolean>(apiUrl);
    }

    //账单现金收款查询
    cashPage(param: IBillCashSearch) {
        const apiUrl = "/bill/cash/page";
        return httpRequest
            .post<IPage<IBillCashDetail>>(apiUrl, param);
    }

    //账单日志查询
    logPage(param: IBillLogSearch) {
        const apiUrl = "/bill/log/page";
        return httpRequest
            .post<IPage<IBillLogDetail>>(apiUrl, param);
    }

    //账单导出
    export(param: IBillLogSearch) {
        const apiUrl = "/bill/export";
        return httpRequest
            .postFile(apiUrl, param, { timeout: LONG_REQUEST_TIMEOUT });
    }

    //账单批量导入
    import(param: IBillLogSearch) {
        const apiUrl = "/bill/impot";
        return httpRequest
            .postFile(apiUrl, param, { timeout: LONG_REQUEST_TIMEOUT });
    }

    //账单监测查询
    monitorPage(param: IBillLogSearch) {
        const apiUrl = "/scm2/bill/monitoring/page";
        return appHttpRequest
            .post<IPage<IBillLogDetail>>(apiUrl, param);
    }


    //账单监测统计
    monitorStatistic(param: IBillSearch) {
        const apiUrl = "/scm2/bill/monitoring/statistics";
        return appHttpRequest
            .post<IBillSummary>(apiUrl, param);
    }


    //账单监测导出
    monitorExport(param: IBillLogSearch) {
        const apiUrl = "/scm2/bill/monitoring/export";
        return appHttpRequest
            .postFile(apiUrl, param, { timeout: LONG_REQUEST_TIMEOUT });
    }
}

export const billService = new BillService();
